"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCurrency = exports.formatCep = exports.formatPhone = exports.formatCpfCnpj = exports.formatCnpj = exports.formatCpf = exports.formatDateTimeSeconds = exports.formatDateTime = exports.formatDate = exports.formatPercentage = exports.formatNumber = exports.formatCurrency = exports.onlyDigits = void 0;
function onlyDigits(value) {
    return String(value == null ? '' : value).replace(/\D+/g, '');
}
exports.onlyDigits = onlyDigits;
function formatCurrency(value, currency = 'BRL') {
    const number = typeof value === 'number'
        ? value
        : Number(String(value == null ? 0 : value).replace(',', '.'));
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency,
    }).format(Number.isFinite(number) ? number : 0);
}
exports.formatCurrency = formatCurrency;
function formatNumber(value, minimumFractionDigits = 0, maximumFractionDigits = 2) {
    const number = typeof value === 'number'
        ? value
        : Number(String(value == null ? 0 : value).replace(',', '.'));
    return new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits,
        maximumFractionDigits,
    }).format(Number.isFinite(number) ? number : 0);
}
exports.formatNumber = formatNumber;
function formatPercentage(value, maximumFractionDigits = 2) {
    const number = typeof value === 'number'
        ? value
        : Number(String(value == null ? 0 : value).replace(',', '.'));
    return new Intl.NumberFormat('pt-BR', {
        style: 'percent',
        maximumFractionDigits,
    }).format(Number.isFinite(number) ? number / 100 : 0);
}
exports.formatPercentage = formatPercentage;
function toDate(value) {
    if (!value)
        return null;
    if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? null : value;
    }
    const text = String(value);
    const normalized = /^\d{4}-\d{2}-\d{2}$/.test(text)
        ? text + 'T00:00:00'
        : text;
    const date = new Date(normalized);
    return Number.isNaN(date.getTime()) ? null : date;
}
function formatDate(value, fallback = '-') {
    const date = toDate(value);
    return date
        ? new Intl.DateTimeFormat('pt-BR').format(date)
        : fallback;
}
exports.formatDate = formatDate;
function formatDateTime(value, fallback = '-') {
    const date = toDate(value);
    return date
        ? new Intl.DateTimeFormat('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        }).format(date)
        : fallback;
}
exports.formatDateTime = formatDateTime;
function formatDateTimeSeconds(value, fallback = '-') {
    const date = toDate(value);
    return date
        ? new Intl.DateTimeFormat('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        }).format(date)
        : fallback;
}
exports.formatDateTimeSeconds = formatDateTimeSeconds;
function formatCpf(value) {
    const digits = onlyDigits(value).slice(0, 11);
    if (digits.length !== 11)
        return digits;
    return digits.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
}
exports.formatCpf = formatCpf;
function formatCnpj(value) {
    const digits = onlyDigits(value).slice(0, 14);
    if (digits.length !== 14)
        return digits;
    return digits.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
}
exports.formatCnpj = formatCnpj;
function formatCpfCnpj(value) {
    const digits = onlyDigits(value);
    if (digits.length <= 11)
        return formatCpf(digits);
    return formatCnpj(digits);
}
exports.formatCpfCnpj = formatCpfCnpj;
function formatPhone(value) {
    const digits = onlyDigits(value).slice(0, 11);
    if (digits.length === 11) {
        return digits.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
    }
    if (digits.length === 10) {
        return digits.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
    }
    return digits;
}
exports.formatPhone = formatPhone;
function formatCep(value) {
    const digits = onlyDigits(value).slice(0, 8);
    if (digits.length !== 8)
        return digits;
    return digits.replace(/^(\d{5})(\d{3})$/, '$1-$2');
}
exports.formatCep = formatCep;
function parseCurrency(value) {
    const text = String(value == null ? '' : value)
        .replace(/[^\d,.-]/g, '')
        .replace(/\./g, '')
        .replace(',', '.');
    const number = Number(text);
    return Number.isFinite(number) ? number : 0;
}
exports.parseCurrency = parseCurrency;
//# sourceMappingURL=formatters.js.map